import { useMutation } from '@apollo/client';
import { gql } from '@/__generated__';

export const LearningProgressQuery = gql(`
  query LearningProgressQuery {
    learningProgress {
      availablePoints
      completedMilestones {
        type
        completedAt
        pointsAwarded
      }
      availableMilestones {
        type
        title
        description
        pointsReward
        completed
      }
      videos {
        id
        title
        description
        s3Key
        pointsReward
        watched
      }
    }
  }
`);

const MARK_VIDEO_WATCHED_MUTATION = gql(`
  mutation MarkLearningVideoWatched($videoId: String!) {
    markLearningVideoWatched(videoId: $videoId) {
      availablePoints
      completedMilestones {
        type
        completedAt
        pointsAwarded
      }
      availableMilestones {
        type
        title
        description
        pointsReward
        completed
      }
      videos {
        id
        title
        description
        s3Key
        pointsReward
        watched
      }
    }
  }
`);

export const useMarkVideoWatched = () => {
  const [markWatched, { loading }] = useMutation(MARK_VIDEO_WATCHED_MUTATION, {
    update(cache, { data }) {
      if (data?.markLearningVideoWatched) {
        cache.writeQuery({
          query: LearningProgressQuery,
          data: { learningProgress: data.markLearningVideoWatched },
        });
      }
    },
  });

  return {
    markVideoWatched: (videoId: string) =>
      markWatched({ variables: { videoId } }),
    loading,
  };
};
